import type { FacilityWorkflowStagePayload } from '@Application/Facilities/Workflows/Actions/facilityWorkflowsFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * One stage of a proposed group: the document types it produces, by id (labels come from `documentTypesStore`).
 */
class FacilityWorkflowStageView {
	readonly stage: number;
	readonly documentTypeIds: readonly number[];

	constructor(payload: FacilityWorkflowStagePayload) {
		this.stage = payload.stage;
		this.documentTypeIds = payload.documentTypes.map((documentType) => documentType.id);

		Object.freeze(this);
	}
}

export default FacilityWorkflowStageView;
